import type { AppEvent, NotificationPreferenceType, UserDto } from '../user/user.interface';

export enum SenderEntity {
  USER = 'User',
  CLUB = 'Club',
  APP = 'App',
}

export interface NotificationDto {
  id: string;
  title: string;
  body: string;
  path: string;
  read: boolean;
  entityId: string;
  entityName: string;
  threadId?: string;
  senderEntityName: SenderEntity;
  sender: UserDto;
  userId: UserDto;
  createdAt: string;
  updatedAt: string;
  profileImageBlobHash: string | null;
  type: NotificationPreferenceType;
  event?: AppEvent;
}
